import React from "react";
import colorGroups from "./__ColorGroups";
import ShowGroupColors from "./__ShowGroupColors";

const textColors = colorGroups.find((group) => group.group === "Text Colors");

const TextSection: React.FC = () => (
  <div className="w-full flex flex-col bg-bg-base px-4">
    <div className="container mx-auto max-w-3xl py-20">
      <div className="flex items-center justify-center">
        <img
          src="/images/logo-square.png"
          alt="RepMates logo"
          width="512"
          height="512"
          className="w-24 h-auto"
        />
      </div>

      <h1 className="text-5xl md:text-6xl font-extrabold text-tx-dark text-center leading-tight mb-10">
        Text Colors
      </h1>

      <div className="w-full bg-white  border border-bd-base rounded-lg p-4 md:p-20 mb-10">
        {textColors && (
          <ShowGroupColors
            colorGroup={textColors}
            gridColsClass="md:grid-cols-1"
          />
        )}

        <p className="mt-10 text-tx-dark font-bold text-2xl">
          这是 <span className="font-bold">tx-dark</span> 文字，主要用于标题。
        </p>

        <p className="mt-4 text-tx-default font-normal text-lg">
          这是 <span className="font-bold">tx-default</span>{" "}
          文字。它是大多数元素的默认文字颜色。例如，文章或描述的正文。当你需要显示
          <span className="font-bold text-tx-muted">
            不重要的文字时可以使用 tx-muted 样式。
          </span>
        </p>

        <p className="mt-1 text-tx-default font-normal text-lg">
          有时你想要强调某段文字，可以使用
          <span className="font-bold text-tx-primary">tx-primary</span> 文字。
          <span className=" text-tx-primary">
            它是重要元素的主色文字。例如，标题或按钮的文字。
          </span>
        </p>

        <p className="mt-1 text-tx-default font-normal text-lg">
          最后，如果你想显示错误信息，请使用
          <span className="font-bold text-tx-error">tx-error</span> 文字。
        </p>

        <p className="mt-10 text-tx-dark font-bold text-2xl">
          This is <span className="font-bold">tx-dark</span> text, mainly for
          titles.
        </p>

        <p className="mt-4 text-tx-default font-normal text-lg">
          This is <span className="font-bold">tx-default</span> text. It is the
          default text color for most elements. For example, the text of an
          article or description. Sometime you need use{" "}
          <span className="font-bold text-tx-muted">
            tx-muted style for not important text.
          </span>
        </p>

        <p className="mt-1 text-tx-default font-normal text-lg">
          Sometimes you want to emphasize a text, use{" "}
          <span className="font-bold text-tx-primary">tx-primary</span> text.{" "}
          <span className=" text-tx-primary">
            It is the primary text color for important elements. For example,
            the text of a heading or a button.
          </span>
        </p>

        <p className="mt-1 text-tx-default font-normal text-lg">
          Lastly, if you want to show an error message, use{" "}
          <span className="font-bold text-tx-error">tx-error</span> text.
        </p>
      </div>
    </div>
  </div>
);

export default TextSection;
